<div class="container-fluid"
  [ngClass]="{'mt-4': ['simple_form', 'form_builder_dashboard'].includes(pageFormType), 'mt-3 background-on-master-list-padding': pageFormType === 'master_listing_table' }">
  <div class="background-on-master-list">
    <div class="row" *ngIf="pageFormType === 'master_listing_table' && hideBackButton === false">
      <div class="col">
        <div class="back-link" (click)="goBack()">&#60; Back</div>
      </div>
    </div>
    <div class="row"
      *ngIf="pageFormType === 'simple_form' && buildFormatTypeId !== 1483 && this.prevRedirectPageFormId && !saveCancelBtn?.back && isFBUser && hideBackButton === false">
      <div class="col">
        <div class="back-link" (click)="onBack(true, this.prevRedirectPageFormId)">&#60; Back</div>
      </div>
    </div>
    <div class="row"
      *ngIf="pageFormType === 'simple_form' && buildFormatTypeId !== 1483 && this.prevRedirectPageFormId && saveCancelBtn?.back && hideBackButton === false">
      <div class="col">
        <div class="back-link"
          (click)="onBack(saveCancelBtn.onBackAction?.isRedirect, saveCancelBtn.onBackAction?.pageFormId)">&#60; Back
        </div>
      </div>
    </div>
    <div class="row mb-4" *ngIf="pageFormType === 'master_listing_table'">
      <div class="col">
        <ng-template [ngIf]="simpleFormButton?.name !== 'fb-simple-form-build-form-type'">
          <span class="fb-page-title">{{ simpleFormButton?.name }}</span>
        </ng-template>
      </div>
    </div>

    <form [formGroup]="stepsForm">
      <div class="row pb-3" *ngFor="let row of htmlStructure">
        <ng-template ngFor let-formField [ngForOf]="row.columns" let-i="index">
          <div
            *ngIf="!formField.selectedRoles || formField.selectedRoles.length === 0 || formField.showContainerBasedonRole"
            [ngClass]="{'col-4': formField.numberOfColumn && formField.numberOfColumn === 4, 'col-6': formField.numberOfColumn && formField.numberOfColumn === 6, 'col-8': formField.numberOfColumn && formField.numberOfColumn === 8, 'col-12': formField.numberOfColumn && formField.numberOfColumn === 12}">
            <label class="label-cls col d-block pl-0"
              [ngClass]="{'bold_font': formField.properties?.setBoldFont && formField.properties?.setBoldFont === true}"
              *ngIf="!labelNotNeededArray.includes(formField.layoutCode)">
              {{formField.label}}<em class="error"
                *ngIf="(formField.layoutCode === 'VdCustomFileUploadComponent' || formField.layoutCode === 'CustomChipComponent' || formField.layoutCode === 'CustomCheckboxComponent') && formField?.mandatory">*</em></label>
            <app-component-loader [rendercomponent]="formField.layoutCode" [sublabel]="formField.subText" class="child"
              [validation]="formField.mandatory" [readonly]="formField.readonly" [minLength]="formField.minLength"
              [maxLength]="formField.maxLength" [placeHolders]="formField.placeholder" #child
              [groupElementProperty]="formField.groupElementProperty" [formControlName]="formField.name"
              [value]="formField.value" [group]="stepsForm" [groupName]="formField.groupName" [inputParams]="formField"
              [fileUploadConfigurations]="formField.layoutCode === 'VdCustomFileUploadComponent' ? fileUploadConfigurations : null"
              [formBuilderInfo]="formBuilderInfo" [htmlRenderObj]="htmlRenderObj">
            </app-component-loader>
          </div>

        </ng-template>
      </div>

      <div class="row mt-4 ml-4" *ngIf="htmlStructure.length > 0 && saveCancelBtn">
        <div class="col-12 mb-4">
          <ng-container *ngIf="isMultiStep && currentStep === steps.length - 1">
            <button *ngIf="saveCancelBtn.cancel" type="button" class="btn btn-secondary cancelBtnMulti"
              (click)="onCancel(saveCancelBtn.onCancelAction?.isRedirect, saveCancelBtn.onCancelAction?.pageFormId)">Cancel</button>
          </ng-container>
          <ng-container>
            <button *ngIf="!isMultiStep && saveCancelBtn.cancel" type="button" class="btn btn-secondary cancelBtn"
              (click)="onCancel(saveCancelBtn.onCancelAction?.isRedirect, saveCancelBtn.onCancelAction?.pageFormId)">Cancel</button>
          </ng-container>
          <ng-template [ngIf]="saveCancelBtn.otherAction">
            <button *ngFor="let action of saveCancelBtn.otherActionDetails" type="button" class="btn btn-primary mr-3"
              (click)="onActionClicked(action.values, action.isRedirect, action.pageFormId, saveCancelBtn.onSaveAction.isCurrentRedirect)">{{action.label}}</button>
          </ng-template>
          <ng-container *ngIf="isMultiStep && currentStep === steps.length - 1 && !simpleFormButton.isMultiDataSrc">
            <button *ngIf="saveCancelBtn.save && saveCancelBtn.onSaveAction" [disabled]="!stepsForm.valid" type="button"
              class="btn btn-primary mr-3 multi-save"
              (click)="onSave(saveCancelBtn.onSaveAction.isRedirect, saveCancelBtn.onSaveAction.pageFormId, saveCancelBtn.onSaveAction.isCurrentRedirect)">{{
              saveCancelBtn.onSaveAction.isRename &&
              saveCancelBtn.onSaveAction.reName && saveCancelBtn.onSaveAction.reName.trim()
              !== '' ? saveCancelBtn.onSaveAction.reName.trim() : 'Save' }}</button>
          </ng-container>
          <ng-container *ngIf="isMultiStep && simpleFormButton.isMultiDataSrc">
            <button *ngIf="saveCancelBtn.save && saveCancelBtn.onSaveAction" [disabled]="!stepsForm.valid" type="button"
              class="btn btn-primary mr-3 multi-save"
              (click)="onSave(saveCancelBtn.onSaveAction.isRedirect, saveCancelBtn.onSaveAction.pageFormId, saveCancelBtn.onSaveAction.isCurrentRedirect)">{{
              saveCancelBtn.onSaveAction.isRename &&
              saveCancelBtn.onSaveAction.reName && saveCancelBtn.onSaveAction.reName.trim()
              !== '' ? saveCancelBtn.onSaveAction.reName.trim() : 'Save' }}</button>
          </ng-container>
          <button *ngIf="!isMultiStep && saveCancelBtn.save && saveCancelBtn.onSaveAction" [disabled]="!stepsForm.valid"
            type="button" class="btn btn-primary mr-3"
            (click)="onSave(saveCancelBtn.onSaveAction.isRedirect, saveCancelBtn.onSaveAction.pageFormId, saveCancelBtn.onSaveAction.isCurrentRedirect)">{{
            saveCancelBtn.onSaveAction.isRename &&
            saveCancelBtn.onSaveAction.reName && saveCancelBtn.onSaveAction.reName.trim()
            !== '' ? saveCancelBtn.onSaveAction.reName.trim() : 'Save' }}</button>
          <button *ngIf="saveCancelBtn.save && !saveCancelBtn.onSaveAction" type="button" class="btn btn-primary mr-3"
            (click)="onSave(false, null, false)">Save</button>
          <button type="button" *ngIf="pageFormType !== 'master_listing_table' && !isFBUser"
            class="btn btn-light mr-3">Publish</button>
          <!-- <ng-container *ngIf="isMultiStep && currentStep === steps.length - 1">
              <button *ngIf="saveCancelBtn.cancel" type="button" class="btn btn-secondary"
              (click)="onCancel(saveCancelBtn.onCancelAction?.isRedirect, saveCancelBtn.onCancelAction?.pageFormId)">Cancel</button>
            </ng-container>
            <ng-container *ngIf="!isCreateTimeSheetSubmit">
              <button *ngIf="!isMultiStep && saveCancelBtn.cancel" type="button" class="btn btn-secondary"
                (click)="onCancel(saveCancelBtn.onCancelAction?.isRedirect, saveCancelBtn.onCancelAction?.pageFormId)">Cancel</button>
            </ng-container> -->
        </div>
      </div>
    </form>
  </div>
</div>